import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import SupportTicketModal from './SupportTicketModal';

const HelpButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <IconButton
        aria-label="help"
        onClick={handleOpenModal}
        sx={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 1000, // Below modals (which are typically 1300+)
          width: '40px',
          height: '40px',
          backgroundColor: '#1e1f26',
          color: '#ffffff',
          fontSize: '20px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#2d2e38',
          },
        }}
      >
        ?
      </IconButton>
      
      <SupportTicketModal 
        open={isModalOpen} 
        onClose={handleCloseModal} 
      />
    </>
  );
};

export default HelpButton;

